import { format, parse } from "date-fns";
import { type Locale, enUS, uk, pl } from "date-fns/locale";
import { i18n } from "../../i18n/i18n";

const localeMap: Record<string, Locale> = {
    EN: enUS,
    UK: uk,
    PL: pl,
};

const getLocale = (): Locale => localeMap[i18n.language] ?? enUS;

export const getDatepickerDateFormat = () => {
    const locale = getLocale();
    const shortDate = locale.formatLong!.date({ width: "short" });
    // Normalize single "y" to "yyyy" for react-datepicker compatibility
    return shortDate.replace(/\by\b/g, "yyyy");
};

export const dateISOSerializer = (date: Date) => date.toISOString();

export const dateDeserializer = (serializedDate: string) => new Date(serializedDate);

export const dateUTCMidnightSerializer = (date: Date) => {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    return utcDate.toISOString();
};

export const dateLocalShortSerializer = (date: Date) => format(date, "yyyy-MM-dd");

export const timeFormatter = (time: string) => {
    const parsed = parse(time, "HH:mm", new Date(2000, 0, 1));
    return format(parsed, "p", { locale: getLocale() });
};

export const dateShortMonthYearFormatter = (date: Date) => {
    return format(date, "MMM yyyy", { locale: getLocale() });
};

export const dateDayMonthYearFormatter = (date: Date) => {
    return format(date, "dd.MM.yyyy");
};

export const dateDayMonthYearHourMinFormatter = (date: Date) => {
    return format(date, "dd.MM.yyyy HH:mm");
};
